const translations = {
    leftInfo: {
        type: 'text',
        defaultValue: '<span class="text-green text-bigger">LIMITOWANA OFERTA</span> <br/>Testuj Gruzillę przez 3 miesiące <br/> <span class="text-green">Za darmo i bez żadnych zobowiązań!</span>',
    },
    inputUserName: {
        type: 'text',
        defaultValue: 'Imię i Naziwsko',
    },
    inputEmail: {
        type: 'text',
        defaultValue: 'Adres e-mail',
    },
    inputPhone: {
        type: 'text',
        defaultValue: 'Numer telefonu',
    },
    inputMessage: {
        type: 'text',
        defaultValue: 'Wiadomość',
    },
    placeholderMessage: {
        type: 'text',
        defaultValue: 'Napisz dane Twojej firmy i że chcesz testować Gruzille',
    },
    submitForm: {
        type: 'text',
        defaultValue: 'Wyślij',
    },
    resultFormTitle: {
        type: 'text',
        defaultValue: 'Dziękujemy za wiadomość!',
    },
    resultFormDescription: {
        type: 'text',
        defaultValue: 'Postaramy się skontaktować z Tobą najszybciej jak to możliwe.',
    },
    rodo: {
        type: 'text',
        defaultValue: 'Administratorem Twoich danych osobowych jest Gruzilla sp. z o.o. z siedzibą w Lublinie (20-027), ul. Sądowa 2/11. Twoje dane osobowe będą przetwarzane w celu odpowiedzi na Twoją wiadomość oraz archiwizacji formularza. Więcej informacji znajdziesz w naszym <a class=\'link\' href=\'/regulamin.pdf\'>Regulaminie</a> i <a class=\'link\' href=\'/polityka-prywatnosci.pdf\'>Polityce Prywatności</a>. ',
    },
};

export default translations;
